import { SxProps, Theme } from '@mui/material';

export const standardCardHeight = 450; // Standard height for all cards
export const imageHeight = 250; // Standard height for card images

export const standardCardStyle: SxProps<Theme> = {
  height: standardCardHeight,
  width: '300px',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: (theme) => theme.shadows[4],
  },
  overflow: 'hidden', // Prevent content overflow
};

export const cardMediaStyle: SxProps<Theme> = {
  height: imageHeight,
  width: '100%',
  objectFit: 'cover',
  objectPosition: 'top',
};

export const cardContentStyle: SxProps<Theme> = {
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
  overflow: 'hidden', // Ensure content doesn't overflow
};

export const cardTitleStyle: SxProps<Theme> = {
  fontWeight: 'bold',
  mb: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  minHeight: '2em', // Ensure consistent height for 2 lines
};

export const cardExcerptStyle: SxProps<Theme> = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  width: '100%',
  mb: 1,
  minHeight: '1.8em', // Ensure consistent height for 3 lines
  lineHeight: 1.5,
  color: 'text.secondary',
}; 